import { render, staticRenderFns } from "./ExtensionsHintsCol.vue?vue&type=template&id=5a234d4b&scoped=true&"
import script from "./ExtensionsHintsCol.vue?vue&type=script&lang=js&"
export * from "./ExtensionsHintsCol.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionsHintsCol.vue?vue&type=style&index=0&id=5a234d4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a234d4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
